import { render, staticRenderFns } from "./Evolucao.vue?vue&type=template&id=5ceddbc0&scoped=true"
import script from "./Evolucao.vue?vue&type=script&lang=js"
export * from "./Evolucao.vue?vue&type=script&lang=js"
import style0 from "./Evolucao.vue?vue&type=style&index=0&id=5ceddbc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ceddbc0",
  null
  
)

export default component.exports